import config from '../config';
import AjaxHelper from './AjaxHelper';
import TokenHelper from './TokenHelper';
import { ALPN_ENABLED } from 'constants';

class CFScriptHelper {
    loadJs(url) {
        const script = document.createElement('script');
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
        return new Promise((resolve, reject) => {
            script.onload = function () {
                resolve(true);
            };

            script.onerror = function (e) {
                reject(e);
            };
        });
    }

    getCFScripts() {
        return this.loadJs(
            `${config.remoteUrl}/CFScripts/GetScripts?v=${Date.now()}`
        );
    }

    getCFServiceProxies() {
        return this.loadJs(
            `${config.remoteUrl}/CFServiceProxies/GetAll?type=jquery`
        );
    }

    initSignalR(callback) {
        // jQuery.getScript('/dist/cf.signalr-client.js', () => {
        //     
        //     $.connection.hub.url = config.remoteUrl + '/signalr';
        //     const encryptedAuthToken = TokenHelper.getEncryptedAccessToken();
        //     $.connection.hub.qs = `${
        //         config.EncryptedAccessTokenKey
        //         }=${encodeURIComponent(encryptedAuthToken)}`;

        //     jQuery.getScript(config.baseUrl + '/static/cf/cf.signalr.js');
        //     callback();
        // });
        //this.loadJs(`/dist/cf.signalr-client.js`);
        const encryptedAuthToken = TokenHelper.getEncryptedAccessToken();
        var qs = `${config.EncryptedAccessTokenKey}=${encodeURIComponent(encryptedAuthToken)}`;
        cf.signalr =
            {
                autoConnect: true,
                connect: undefined,
                hubs: undefined,
                qs: qs,
                url: config.remoteUrl + '/signalr'
            };
        jQuery.getScript('/dist/cf.signalr-client.js', () => {
            callback();
        });
    }

    async getCFUserCfg() {
        const cookieLangValue = cf.utils.getCookieValue(
            'Abp.Localization.CultureName'
        );
        var accessToken = TokenHelper.getAccessToken();
        var tentantId = cf.multiTenancy.getTenantIdCookie();
        var rs = await AjaxHelper.get(
            `${config.remoteUrl}/AbpUserConfiguration/GetAll`,
            null,
            {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + accessToken,
                    '.AspNetCore.Culture':
                        'c=' + cookieLangValue + '|uic=' + cookieLangValue,
                    'Abp.TenantId': tentantId
                }
            }
        );

        return rs;
    }
}

export default new CFScriptHelper();
